import {
    GET_CMS_CERTIFICACIONES,
    GET_CMS_CERTIFICACIONES_ERROR
} from "./types";
import CMSService from "../../services/cms.service";

export function getCertificaciones() {
    return function (dispatch) {
        try {           
            return CMSService.reqCeritificaciones()
                .then((data) => {                                       
                    dispatch(
                        {
                            type: GET_CMS_CERTIFICACIONES,
                            payload: data
                        })
                });
        }
        catch (error) {
            return (dispatch) => {
                dispatch({
                    type: GET_CMS_CERTIFICACIONES_ERROR,
                });
            }
        }
    };
}